module.exports = __webpack_public_path__ + "static/media/first.b041054f.png";